import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/acp-mobile-sdkdocs/acp-mobile-sdkdocs/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "2019"
    }}>{`2019`}</h1>
    <h2 {...{
      "id": "november-15-2019"
    }}>{`November 15, 2019`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "ios-identity-213released-with-acpcore-version-236-on-cocoapods"
    }}>{`iOS Identity 2.1.3(Released with ACPCore version 2.3.6 on Cocoapods)`}</h3>
    <ul>
      <li parentName="ul">{`Synced custom and advertising identifiers with nil or empty values are now cleared from Identity shared state and local storage. They are also not synced with the Experience Cloud ID (ECID) Service.`}</li>
      <li parentName="ul">{`Fixed a threading issue where the Experience Cloud ID (ECID) Service response was handled on an incorrect thread potentially causing a memory corruption crash.`}</li>
    </ul>
    <p>{`These changes were released as part of ACPCore CocoaPod v2.3.6.`}</p>
    <h2 {...{
      "id": "november-8-2019"
    }}>{`November 8, 2019`}</h2>
    <p>{`The following update was made in this release:`}</p>
    <h3 {...{
      "id": "ios-mobile-services-104"
    }}>{`iOS Mobile Services 1.0.4`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a bug where the iOS fullscreen message was unable to load cached images.`}</li>
    </ul>
    <h2 {...{
      "id": "october-30-2019"
    }}>{`October 30, 2019`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-campaign-102"
    }}>{`Android Campaign 1.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a bug where full-screen message interaction tracking was not working when a message was dismissed.`}</li>
      <li parentName="ul">{`Added support for local notification message metrics (impression, open, and click).`}</li>
      <li parentName="ul">{`Added support for message frequency rules (show once and until clicked) for local notification messages.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-campaign-104"
    }}>{`iOS Campaign 1.0.4`}</h3>
    <ul>
      <li parentName="ul">{`Added support for local notification message metrics (impression, open, and click).`}</li>
      <li parentName="ul">{`Added support for message frequency rules (show once and until clicked) for local notification messages.`}</li>
    </ul>
    <h2 {...{
      "id": "october-28-2019"
    }}>{`October 28, 2019`}</h2>
    <p>{`The following changes were made in this release:`}</p>
    <h3 {...{
      "id": "android-campaign-standard-110"
    }}>{`Android Campaign Standard 1.1.0`}</h3>
    <ul>
      <li parentName="ul">{`In the tags extension, added the ability to reset the `}<inlineCode parentName="li">{`pkey`}</inlineCode>{`.`}</li>
    </ul>
    <h3 {...{
      "id": "android-analytics-122"
    }}>{`Android Analytics 1.2.2`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Analytics response content events now contain two new fields:`}</p>
        <ul parentName="li">
          <li parentName="ul"><inlineCode parentName="li">{`hitHost`}</inlineCode></li>
          <li parentName="ul"><inlineCode parentName="li">{`hitUrl`}</inlineCode></li>
        </ul>
        <p parentName="li">{`These fields contain the host and URL of the of the hit responsible for dispatching the response event.`}</p>
      </li>
    </ul>
    <h3 {...{
      "id": "ios-campaign-standard-110"
    }}>{`iOS Campaign Standard 1.1.0`}</h3>
    <ul>
      <li parentName="ul">{`In the tags extension, added the ability to reset the `}<inlineCode parentName="li">{`pkey`}</inlineCode>{`.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-analytics-221"
    }}>{`iOS Analytics 2.2.1`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Analytics response content events now contain two new fields:`}</p>
        <ul parentName="li">
          <li parentName="ul"><inlineCode parentName="li">{`hitHost`}</inlineCode></li>
          <li parentName="ul"><inlineCode parentName="li">{`hitUrl`}</inlineCode></li>
        </ul>
        <p parentName="li">{`These fields contain the host and URL of the of the hit responsible for dispatching the response event.`}</p>
      </li>
    </ul>
    <h2 {...{
      "id": "october-25-2019"
    }}>{`October 25, 2019`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-core-145-released-with-sdk-core-version-146-on-maven"
    }}>{`Android Core 1.4.5 (Released with sdk-core version 1.4.6 on Maven)`}</h3>
    <ul>
      <li parentName="ul">{`Added support for attach data rules consequence.`}</li>
      <li parentName="ul">{`Added support for a boolean-type comparison for the `}<inlineCode parentName="li">{`Exist`}</inlineCode>{` or `}<inlineCode parentName="li">{`Not Exist`}</inlineCode>{` rules condition.`}</li>
      <li parentName="ul">{`Fixed a bug where the `}<inlineCode parentName="li">{`Exist`}</inlineCode>{` and `}<inlineCode parentName="li">{`Not Exist`}</inlineCode>{` rules condition might not work for a `}<inlineCode parentName="li">{`List`}</inlineCode>{` or `}<inlineCode parentName="li">{`Map`}</inlineCode>{` type value.`}</li>
      <li parentName="ul">{`Fixed a bug that, when fetching the remote config from Launch, might cause a crash on some Android devices.`}</li>
      <li parentName="ul">{`Fixed a bug that, when the data URL of an activity did not contain valid schema, might cause a crash.`}</li>
    </ul>
    <h3 {...{
      "id": "android-identity-112"
    }}>{`Android Identity 1.1.2`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a bug where the default Experience Cloud Server hostname is now used when no value is configured in the SDK.`}</li>
      <li parentName="ul">{`Fixed a bug where multiple custom identifiers with same `}<inlineCode parentName="li">{`idType`}</inlineCode>{` value were synced with the Visitor ID Service.`}</li>
      <li parentName="ul">{`Custom visitor identifiers can now be cleared from the SDK by providing a null/empty identifier value for a previously synced `}<inlineCode parentName="li">{`idType`}</inlineCode>{`.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-core-235"
    }}>{`iOS Core 2.3.5`}</h3>
    <ul>
      <li parentName="ul">{`Added support for the attach data rules consequence.`}</li>
      <li parentName="ul">{`Added support for a boolean-type comparison for the `}<inlineCode parentName="li">{`Exist`}</inlineCode>{` or `}<inlineCode parentName="li">{`Not Exist`}</inlineCode>{` rules condition.`}</li>
    </ul>
    <h2 {...{
      "id": "october-10-2019"
    }}>{`October 10, 2019`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "ios-campaign-classic-201"
    }}>{`iOS Campaign Classic 2.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an issue where, on iOS 13, the push token was not being extracted correctly from NSData during device registration.    `}</li>
      <li parentName="ul">{`Fixed an issue where the charset information was not being sent in the Content-Type header during device registration call.`}</li>
    </ul>
    <h2 {...{
      "id": "october-7-2019"
    }}>{`October 7, 2019`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-analytics-121"
    }}>{`Android Analytics 1.2.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a bug where, on start up, the Analytics database was being modified by multiple threads.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-mobile-services-103"
    }}>{`iOS Mobile Services 1.0.3`}</h3>
    <ul>
      <li parentName="ul">{`Full-screen messages now use `}<inlineCode parentName="li">{`WKWebViews`}</inlineCode>{` from the `}<inlineCode parentName="li">{`WebKit.framework`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`Local notifications now use the `}<inlineCode parentName="li">{`UserNotifications`}</inlineCode>{` framework.`}</li>
      <li parentName="ul">{`Fixed a crash that might happen when the `}<strong parentName="li">{`Click-Through`}</strong>{` or the `}<strong parentName="li">{`Cancel`}</strong>{` button in the Full-screen message was clicked more than once.`}</li>
    </ul>
    <h2 {...{
      "id": "october-4-2019"
    }}>{`October 4, 2019`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "ios-core-234"
    }}>{`iOS Core 2.3.4`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a crash that might have happened during app shutdown..    `}</li>
      <li parentName="ul">{`Fixed a bug where, when the SDK is being used in multiple threads, the SDK might not function under a race condition..    `}</li>
      <li parentName="ul">{`Fixed a bug where the downloaded rules zip file might not be decompressed.    `}</li>
      <li parentName="ul">{`Fixed a bug where the `}<inlineCode parentName="li">{`getSdkIdentities`}</inlineCode>{` API used wrong key names for the Push ID and IDFA.    `}</li>
      <li parentName="ul">{`Removed the usage of UIWebView.    `}</li>
      <li parentName="ul">{`Extension listeners with null/empty type or source is now invalid and will not be registered.    `}</li>
    </ul>
    <h3 {...{
      "id": "ios-identity-212"
    }}>{`iOS Identity 2.1.2`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an issue where the push identifier is not contained in the Identity shared state on bootup.    `}</li>
      <li parentName="ul">{`Fixed an issue where `}<inlineCode parentName="li">{`appendToUrl`}</inlineCode>{` uses the incorrect query delimiter when the source URL contains a question mark in its fragment identifier component.`}</li>
    </ul>
    <h2 {...{
      "id": "october-2-2019"
    }}>{`October 2, 2019`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-target-113"
    }}>{`Android Target 1.1.3`}</h3>
    <ul>
      <li parentName="ul">{`The Target session ID and Edge Host will now be persisted in Shared Preferences. If there is no activity for the configured `}<inlineCode parentName="li">{`target.sessionTimeout`}</inlineCode>{`, these variables will be reset. The default session timeout value is 30 minutes.    `}</li>
      <li parentName="ul">{`Fixed an issue where the null `}<inlineCode parentName="li">{`at_property`}</inlineCode>{` key, which was passed in mbox parameters, was being sent in Target requests.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-target-214"
    }}>{`iOS Target 2.1.4`}</h3>
    <ul>
      <li parentName="ul">{`The Target session ID and Edge Host will now be persisted in NSUserDefaults. If there is no activity for the configured `}<inlineCode parentName="li">{`target.sessionTimeout`}</inlineCode>{`, these variables will be reset. The default session timeout value is 30 minutes.    `}</li>
    </ul>
    <h2 {...{
      "id": "september-24-2019"
    }}>{`September 24, 2019`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "ios-audience-201"
    }}>{`iOS Audience 2.0.1`}</h3>
    <ul>
      <li parentName="ul">{`The `}<inlineCode parentName="li">{`global.ssl`}</inlineCode>{` configuration settings are ignored, and SSL is enabled by default.`}</li>
      <li parentName="ul">{`Appends IMS OrgID to AAM demdex calls if subdomain endpoint is missing.`}</li>
    </ul>
    <h2 {...{
      "id": "september-17-2019"
    }}>{`September 17, 2019`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-core-144-released-with-sdk-core-version-145-on-maven"
    }}>{`Android Core 1.4.4 (Released with sdk-core version 1.4.5 on Maven)`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Starting in API level 16, notifications now support `}<inlineCode parentName="p">{`BigTextStyle`}</inlineCode>{`.`}</p>
        <p parentName="li">{`This enables long notifications to be displayed without being truncated.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Fixed the locale string in the HTTP User-Agent to follow the BCP 47 specification.`}</p>
      </li>
    </ul>
    <h2 {...{
      "id": "september-10-2019"
    }}>{`September 10, 2019`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-analytics-120"
    }}>{`Android Analytics 1.2.0`}</h3>
    <ul>
      <li parentName="ul">{`Added the following new pieces of data when reporting a crash:`}
        <ul parentName="li">
          <li parentName="ul"><inlineCode parentName="li">{`previousosversion`}</inlineCode></li>
          <li parentName="ul"><inlineCode parentName="li">{`previousappid`}</inlineCode>{`.`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Added support for the Griffon debug API.`}</li>
      <li parentName="ul">{`The `}<inlineCode parentName="li">{`global.ssl`}</inlineCode>{` configuration settings are ignored, and SSL is enabled by default.`}</li>
    </ul>
    <h2 {...{
      "id": "september-9-2019"
    }}>{`September 9, 2019`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-identity-111-released-with-sdk-core-version-144-on-maven"
    }}>{`Android Identity 1.1.1 (Released with sdk-core version 1.4.4 on Maven)`}</h3>
    <ul>
      <li parentName="ul">{`Custom identifiers with null or empty IDs are ignored when calling the `}<inlineCode parentName="li">{`syncIdentifier`}</inlineCode>{` or `}<inlineCode parentName="li">{`syncIdentifiers`}</inlineCode>{` APIs because the Visitor ID Service does not support these identifiers.`}</li>
      <li parentName="ul">{`The `}<inlineCode parentName="li">{`syncIdentifiers`}</inlineCode>{` API call is ignored when there is an empty Map.`}</li>
      <li parentName="ul">{`The duplicate advertising identifier value is removed from the Identity-shared state when `}<inlineCode parentName="li">{`MobileCore.setAdvertisingIdentifier`}</inlineCode>{` is called with a new value.`}</li>
      <li parentName="ul">{`The `}<inlineCode parentName="li">{`global.ssl`}</inlineCode>{` configuration settings are ignored, and SSL is enabled by default.`}</li>
      <li parentName="ul">{`Fixed an issue where `}<inlineCode parentName="li">{`appendVisitorInfoForURL`}</inlineCode>{` uses the wrong query delimiter when the source URL contains a question mark in its fragment identifier component.`}</li>
    </ul>
    <h3 {...{
      "id": "android-griffon-bridge-103"
    }}>{`Android Griffon Bridge 1.0.3`}</h3>
    <ul>
      <li parentName="ul">{`You can use the Android Griffon Bridge version 1.0.3 with the Android Griffon SDK version 1.0.0.`}</li>
    </ul>
    <h3 {...{
      "id": "android-griffon-sdk-100"
    }}>{`Android Griffon SDK 1.0.0`}</h3>
    <ul>
      <li parentName="ul">{`Starting in version 1.0.3, there is a new Artifact split from the Android Griffon Bridge.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-analytics-220"
    }}>{`iOS Analytics 2.2.0`}</h3>
    <ul>
      <li parentName="ul">{`Added support for Griffon debug API.`}</li>
      <li parentName="ul">{`The `}<inlineCode parentName="li">{`global.ssl`}</inlineCode>{` configuration settings are ignored, and SSL is enabled by default.`}</li>
    </ul>
    <h2 {...{
      "id": "august-30-2019"
    }}>{`August 30, 2019`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-mobile-services-101"
    }}>{`Android Mobile Services 1.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added the ability to trigger an In-App message that is based on Analytics rules consequences..`}</li>
    </ul>
    <h3 {...{
      "id": "ios-mobile-services-202"
    }}>{`iOS Mobile Services 2.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Added the ability to trigger an In-App message that is based on Analytics rules consequences..`}</li>
    </ul>
    <h2 {...{
      "id": "august-20-2019"
    }}>{`August 20, 2019`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "ios-core-release-233"
    }}>{`iOS Core release 2.3.3`}</h3>
    <ul>
      <li parentName="ul">{`Reduced the number of threads that were being consumed by the SDK and also reduced the CPU usage of the SDK.`}</li>
      <li parentName="ul">{`Fixed a memory leak issue.`}</li>
      <li parentName="ul">{`Several minor fixes for the Local Notification.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-identity-release-211"
    }}>{`iOS Identity release 2.1.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a bug where the push identifier was not updated in the Identity-shared state when `}<inlineCode parentName="li">{`setPushIdentifier`}</inlineCode>{` was called.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-lifecycle-release-203"
    }}>{`iOS Lifecycle release 2.0.3`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a bug in the App ID string where `}<inlineCode parentName="li">{`CFBundleVersion`}</inlineCode>{` and `}<inlineCode parentName="li">{`CFBundleShortVersionString`}</inlineCode>{` were being concatenated in the wrong order.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-acquisition-release-202"
    }}>{`iOS Acquisition release 2.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a bug where a duplicate Analytics hit was sent when `}<inlineCode parentName="li">{`ACPCore::CollectLaunchInfo`}</inlineCode>{` was called.`}</li>
    </ul>
    <h2 {...{
      "id": "august-8-2019"
    }}>{`August 8, 2019`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "ios-target-213"
    }}>{`iOS Target 2.1.3`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a bug that, when prefetchContent is called with a nil callback, caused a crash in iOS.`}</li>
    </ul>
    <h2 {...{
      "id": "august-6-2019"
    }}>{`August 6, 2019`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-core-142"
    }}>{`Android Core 1.4.2`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Fixed a bug where the replacement value for token `}<inlineCode parentName="p">{`{%~timestampz%}`}</inlineCode>{` might be created with the wrong locale.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Added `}<inlineCode parentName="p">{`getUniqueIdentifier()`}</inlineCode>{` to the `}<inlineCode parentName="p">{`Event`}</inlineCode>{` object.`}</p>
        <p parentName="li">{`This value is a globally unique identifier for every `}<inlineCode parentName="p">{`Event`}</inlineCode>{`.`}</p>
      </li>
    </ul>
    <h3 {...{
      "id": "android-target-112"
    }}>{`Android Target 1.1.2`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`target.previewEnabled`}</inlineCode>{`, a new configuration Boolean key, has been added. This key is used to enable/disable Target Preview.`}</p>
        <p parentName="li">{`If key is not provided, preview is enabled by default.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Fixed an issue in Android where Target Preview links were decoded twice, which lead to an error preview page.`}</p>
      </li>
    </ul>
    <h3 {...{
      "id": "ios-target-212"
    }}>{`iOS Target 2.1.2`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`target.previewEnabled`}</inlineCode>{`, a new configuration Boolean key, has been added. This key is used to enable/disable Target Preview.`}</p>
        <p parentName="li">{`If key is not provided, preview is enabled by default.`}</p>
      </li>
    </ul>
    <h2 {...{
      "id": "july-17-2019"
    }}>{`July 17, 2019`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-core-141"
    }}>{`Android Core 1.4.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an issue that, when making Analytics requests during the switch of Android activities, might result in incorrect Customer Perspective (CP) values.`}</li>
    </ul>
    <h2 {...{
      "id": "july-16-2019"
    }}>{`July 16, 2019`}</h2>
    <h3 {...{
      "id": "adobe-experience-platform-sdk-for-wechat-mini-programs-beta"
    }}>{`Adobe Experience Platform SDK for WeChat Mini Programs Beta`}</h3>
    <p>{`The Adobe Experience Platform SDK now supports WeChat Mini Programs. This beta release helps Adobe Analytics customers who want to track the behavioral usage of Mini Programs. For more information, see the documentation or contact your Adobe customer success manager.`}</p>
    <h2 {...{
      "id": "july-10-2019"
    }}>{`July 10, 2019`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-griffon-bridge-102"
    }}>{`Android Griffon Bridge 1.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Fixed bug where wildcard listener wasn't working.`}</li>
    </ul>
    <h2 {...{
      "id": "july-9-2019"
    }}>{`July 9, 2019`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "ios-analytics-212"
    }}>{`iOS Analytics 2.1.2`}</h3>
    <ul>
      <li parentName="ul">{`ACPAnalytics now correctly identifies Acquisition link event types.`}</li>
      <li parentName="ul">{`Fixes a compile-time error when using the "-all`}{`_`}{`load" linker flag.`}</li>
    </ul>
    <h2 {...{
      "id": "june-28-2019"
    }}>{`June 28, 2019`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-griffon-bridge-101"
    }}>{`Android Griffon Bridge 1.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Initial beta release.`}</li>
    </ul>
    <h2 {...{
      "id": "june-27-2019"
    }}>{`June 27, 2019`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-target-111"
    }}>{`Android Target 1.1.1`}</h3>
    <ul>
      <li parentName="ul">{`Use the `}<inlineCode parentName="li">{`target.propertyToken`}</inlineCode>{` configuration setting to configure the `}<inlineCode parentName="li">{`at_property_token`}</inlineCode>{` that is generated from the Target UI, instead of passing the token as an mbox parameter.`}</li>
      <li parentName="ul">{`Fixed an issue where JSON offers were not being returned as content but instead default content was served.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-target-211"
    }}>{`iOS Target 2.1.1`}</h3>
    <ul>
      <li parentName="ul">{`Use the `}<inlineCode parentName="li">{`target.propertyToken`}</inlineCode>{` configuration setting to configure the `}<inlineCode parentName="li">{`at_property_token`}</inlineCode>{` that is generated from the Target UI, instead of passing the token as an mbox parameter.`}</li>
      <li parentName="ul">{`Fixed an issue where JSON offers were not being returned as content but instead default content was served.`}</li>
    </ul>
    <h2 {...{
      "id": "june-19-2019"
    }}>{`June 19, 2019`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "ios-core-release-232"
    }}>{`iOS Core release 2.3.2`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an issue that, when making Analytics requests immediately after app launch, might result in incorrect Customer Perspective (cp) values.`}</li>
      <li parentName="ul">{`Fixed an issue that might cause the main thread to be blocked for up to 60 seconds while the app is shutting down.`}</li>
      <li parentName="ul">{`Fixed several issues leading to a non-observed crash in the background while the app attempts to shut down.`}</li>
    </ul>
    <h2 {...{
      "id": "june-13-2019"
    }}>{`June 13, 2019`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "ios-core-231"
    }}>{`iOS Core 2.3.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an issue that was causing network request failures, which were introduced in version 2.2.2.`}</li>
      <li parentName="ul">{`Fixed an issue that might have caused crashes when the app was being shut down.`}</li>
      <li parentName="ul">{`Fixed an issue that might have caused the callback to be passed to `}<inlineCode parentName="li">{`ACPCore start:`}</inlineCode>{` to be called before the EventHub has finished initialization.`}</li>
    </ul>
    <h2 {...{
      "id": "june-12-2019"
    }}>{`June 12, 2019`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "ios-analytics-211"
    }}>{`iOS Analytics 2.1.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a bug where the locale was incorrect for Analytics hits.`}</li>
      <li parentName="ul">{`Fixed a bug where the Analytics shared state was not updated with the visitor identifier.`}</li>
    </ul>
    <h2 {...{
      "id": "june-3-2019"
    }}>{`June 3, 2019`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-core-140"
    }}>{`Android Core 1.4.0`}</h3>
    <ul>
      <li parentName="ul">{`Fixed the migration of Custom Analytics ID from v4.`}</li>
      <li parentName="ul">{`Added the `}<inlineCode parentName="li">{`collectMessageInfo`}</inlineCode>{` API to collect push/local notification-related data.`}</li>
      <li parentName="ul">{`Forced the `}{`_`}{`*`}{`*`}{`_`}{`usage of TLS v1.1/v1.2 on the Android 4.x devices (Android API version from 16-19).`}</li>
    </ul>
    <h3 {...{
      "id": "android-signal-102"
    }}>{`Android Signal 1.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an issue where the SSL connection was not kept alive.`}</li>
    </ul>
    <h3 {...{
      "id": "android-identity-110"
    }}>{`Android Identity 1.1.0`}</h3>
    <ul>
      <li parentName="ul">{`Added the `}<inlineCode parentName="li">{`getUrlVariables`}</inlineCode>{` API to retrieve Visitor Identifiers as URL-encoded query strings for hybrid mobile applications.`}</li>
    </ul>
    <h2 {...{
      "id": "may-31-2019"
    }}>{`May 31, 2019`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "ios-core-230"
    }}>{`iOS Core 2.3.0`}</h3>
    <ul>
      <li parentName="ul">{`Fixed several crash issues.`}</li>
      <li parentName="ul">{`Fixed the migration of Custom Analytics ID from v4.`}</li>
      <li parentName="ul">{`Added the `}<inlineCode parentName="li">{`collectMessageInfo`}</inlineCode>{` API to collect push/local notification-related data.`}</li>
      <li parentName="ul">{`Added the support for title and custom sound in local notifications.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-identity-210"
    }}>{`iOS Identity 2.1.0`}</h3>
    <ul>
      <li parentName="ul">{`Added the `}<inlineCode parentName="li">{`getUrlVariables`}</inlineCode>{` API to retrieve Visitor Identifiers as URL-encoded query strings for hybrid mobile applications.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-campaign-102"
    }}>{`iOS Campaign 1.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Added enhanced alert reporting with clickthrough URL support in the Campaign response event.`}</li>
      <li parentName="ul">{`Added support for a custom title in local notifications.`}</li>
    </ul>
    <h2 {...{
      "id": "may-20-2019"
    }}>{`May 20, 2019`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-core-131"
    }}>{`Android Core 1.3.1`}</h3>
    <ul>
      <li parentName="ul">{`Added support for ISO 8601 timestamp for Rules Engine token replacement, you can use the placeholder `}<inlineCode parentName="li">{`~timestampz`}</inlineCode></li>
      <li parentName="ul">{`Fixed the bug where `}<inlineCode parentName="li">{`MobileCore.getSdkIdentities`}</inlineCode>{` didn't return the correct value for Analytics visitor identifier (VID).`}</li>
      <li parentName="ul">{`Added support for migrating Privacy status from v4 to v5, if it was manually set with v4 SDK.`}</li>
      <li parentName="ul">{`Fixed issue where retrieving Privacy status may get delayed when device is offline.`}</li>
      <li parentName="ul">{`Added support for loading cached configuraiton and cached rules on subsequent launch.`}</li>
    </ul>
    <h3 {...{
      "id": "android-identity-105"
    }}>{`Android Identity 1.0.5`}</h3>
    <ul>
      <li parentName="ul">{`Fixed issue where the Analytics visitor identifier (VID) was not included in the `}<inlineCode parentName="li">{`Identity.appendVisitorInfoForURL`}</inlineCode>{` callback value.`}</li>
    </ul>
    <h3 {...{
      "id": "android-campaign-101"
    }}>{`Android Campaign 1.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added enhanced alert reporting with clickthrough URL support in the Campaign response event.`}</li>
      <li parentName="ul">{`Added support for a custom title in local notifications.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-core-222"
    }}>{`iOS Core 2.2.2`}</h3>
    <ul>
      <li parentName="ul">{`Fixed the issue where SSL connection was not kept alive.`}</li>
      <li parentName="ul">{`Added support for ISO 8601 timestamp for Rules Engine token replacement, you can use the placeholder `}<inlineCode parentName="li">{`~timestampz`}</inlineCode></li>
      <li parentName="ul">{`Fixed the bug where `}<inlineCode parentName="li">{`ACPCore.getSdkIdentities`}</inlineCode>{` didn't return the correct value for Analytics visitor identifier (VID).`}</li>
      <li parentName="ul">{`Added support for migrating Privacy status from v4 to v5, if it was manually set with v4 SDK.`}</li>
      <li parentName="ul">{`Fixed issue where retrieving Privacy status may get delayed when device is offline.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-identity-203"
    }}>{`iOS Identity 2.0.3`}</h3>
    <ul>
      <li parentName="ul">{`Fixed issue where device locale was not properly read when creating network requests from Identity extension.`}</li>
      <li parentName="ul">{`Fixed issue where the callback was not called on `}<inlineCode parentName="li">{`ACPIdentity.getIdentifiers`}</inlineCode>{` if no custom identifiers where synced previously.`}</li>
      <li parentName="ul">{`Fixed issue where the Analytics visitor identifier (VID) was not included in the `}<inlineCode parentName="li">{`ACPIdentity.appendToUrl`}</inlineCode>{` callback value.`}</li>
    </ul>
    <h2 {...{
      "id": "may-15-2019"
    }}>{`May 15, 2019`}</h2>
    <h3 {...{
      "id": "android-target-110"
    }}>{`Android Target 1.1.0`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Upgraded the Target Delivery APIs to latest v1 delivery endpoint.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Introduced `}<inlineCode parentName="p">{`retrieveLocationContent`}</inlineCode>{`, a new API that retrieves content for multiple Target mbox locations simultaneously without increasing the reporting count for prefetch cases.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Introduced `}<inlineCode parentName="p">{`locationsDisplayed`}</inlineCode>{`, a new API that helps Target record location to display events.`}</p>
        <p parentName="li">{`This API should only be used for prefetch scenarios.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Provided support for `}<inlineCode parentName="p">{`TargetParameters`}</inlineCode>{` which is a helper class that combines parameters such as `}<inlineCode parentName="p">{`mboxParameters`}</inlineCode>{`, `}<inlineCode parentName="p">{`profileParameters`}</inlineCode>{`, `}<inlineCode parentName="p">{`orderParameters`}</inlineCode>{`, and `}<inlineCode parentName="p">{`productParameters`}</inlineCode>{`.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`New `}<inlineCode parentName="p">{`prefetchContent`}</inlineCode>{` and `}<inlineCode parentName="p">{`locationClicked`}</inlineCode>{` APIs which accept TargetParameters.`}</p>
      </li>
    </ul>
    <h3 {...{
      "id": "ios-target-210"
    }}>{`iOS Target 2.1.0`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Upgraded the Target Delivery APIs to latest v1 delivery endpoint.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Introduced `}<inlineCode parentName="p">{`retrieveLocationContent`}</inlineCode>{`, a new API that retrieves content for multiple Target mbox locations simultaneously without increasing the reporting count for prefetch cases.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Introduced `}<inlineCode parentName="p">{`locationsDisplayed`}</inlineCode>{`, a new API that helps Target record location to display events.`}</p>
        <p parentName="li">{`This API should only be used for prefetch scenarios.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Provided support for `}<inlineCode parentName="p">{`TargetParameters`}</inlineCode>{` which is a helper class that combines parameters such as `}<inlineCode parentName="p">{`mboxParameters`}</inlineCode>{`, `}<inlineCode parentName="p">{`profileParameters`}</inlineCode>{`, `}<inlineCode parentName="p">{`orderParameters`}</inlineCode>{`, and `}<inlineCode parentName="p">{`productParameters`}</inlineCode>{`.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`New `}<inlineCode parentName="p">{`prefetchContent`}</inlineCode>{` and `}<inlineCode parentName="p">{`locationClicked`}</inlineCode>{` APIs which accept TargetParameters.`}</p>
      </li>
    </ul>
    <h2 {...{
      "id": "may-9-2019"
    }}>{`May 9, 2019`}</h2>
    <h3 {...{
      "id": "ios-analytics-210"
    }}>{`iOS Analytics 2.1.0`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a crash related to database multi-threading.`}</li>
      <li parentName="ul">{`Enforced HTTPs network requests.`}</li>
    </ul>
    <p>{`React Native wrappers for the following extensions were pushed to npmjs:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.npmjs.com/package/@adobe/react-native-acpcore"
        }}>{`Core, Identity, Lifecycle, and Signal`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.npmjs.com/package/@adobe/react-native-acpanalytics"
        }}>{`Analytics`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.npmjs.com/package/@adobe/react-native-acpaudience"
        }}>{`Audience`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.npmjs.com/package/@adobe/react-native-acpcampaign"
        }}>{`Campaign`}</a></li>
    </ul>
    <h2 {...{
      "id": "may-6-2019"
    }}>{`May 6, 2019`}</h2>
    <h3 {...{
      "id": "android-core-130"
    }}>{`Android Core 1.3.0`}</h3>
    <ul>
      <li parentName="ul">{`The `}<inlineCode parentName="li">{`MobileCore.start()`}</inlineCode>{` API should only get called once, and the SDK ignores the subsequent calls to this API.`}</li>
      <li parentName="ul">{`Added an internal API for React Native support.`}</li>
    </ul>
    <h2 {...{
      "id": "may-2-2019"
    }}>{`May 2, 2019`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "ios-core-221"
    }}>{`iOS Core 2.2.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an issue when the app network crashes under extreme conditions.`}</li>
    </ul>
    <h2 {...{
      "id": "april-26-2019"
    }}>{`April 26, 2019`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-core-122"
    }}>{`Android Core 1.2.2`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a bug that prevented URLs from being correctly opened on some Android versions.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-core-220"
    }}>{`iOS Core 2.2.0`}</h3>
    <ul>
      <li parentName="ul">{`The `}<inlineCode parentName="li">{`ACPCore.start`}</inlineCode>{` API can only get called once.`}</li>
      <li parentName="ul">{`Added the `}<inlineCode parentName="li">{`ACPCore.registerURLHandler`}</inlineCode>{` API, which allows the app to set a custom handler for click-through URLs.`}</li>
      <li parentName="ul">{`Fixed the problem where the SDK failed to get locale information.`}</li>
      <li parentName="ul">{`Allow the Rules Engine to replace the token for non-string objects.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-analytics-204"
    }}>{`iOS Analytics 2.0.4`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a cocoapod dependency issue.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-mobile-services-201"
    }}>{`iOS Mobile Services 2.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a cocoapod dependency issue.`}</li>
    </ul>
    <h2 {...{
      "id": "april-16-2019"
    }}>{`April 16, 2019`}</h2>
    <p>{`Project Griffon is now available for beta access!`}</p>
    <p>{`Project Griffon is a new, innovative product from Adobe to help you easily inspect, validate, debug data collection and experiences for your mobile app. Developed for app product managers and developers, Project Griffon ensures that your app is correctly implemented, which allows you to focus on creating engaging experiences.`}</p>
    <p>{`Project Griffon is in beta, and the use of this beta release requires you to accept the terms outlined in `}<a parentName="p" {...{
        "href": "https://assurance.adobe.com"
      }}>{`https://assurance.adobe.com`}</a>{`.`}</p>
    <p>{`If you need access, go to `}<a parentName="p" {...{
        "href": "https://assurance.adobe.com"
      }}>{`https://assurance.adobe.com`}</a>{` and `}<a parentName="p" {...{
        "href": "https://forms.office.com/Pages/ResponsePage.aspx?id=Wht7-jR7h0OUrtLBeN7O4UJN9zAhIEhJr3PBfyMf9wdUMjNHTjVCVUJXUDM0VUIzOUFWMk9RNlBLRC4u"
      }}>{`register your interest`}</a>{`.`}</p>
    <h2 {...{
      "id": "april-5-2019"
    }}>{`April 5, 2019`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "ios-core-211"
    }}>{`iOS Core 2.1.1`}</h3>
    <ul>
      <li parentName="ul">{`Core: Internal support for database scheme migration.`}</li>
      <li parentName="ul">{`Identity: Identity MID might be regenerated when privacy settings change from opted out to opted in/opt unknown in the same session.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-analytics-203"
    }}>{`iOS Analytics 2.0.3`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a minor Analytics hit ordering issue.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-mobile-services-100"
    }}>{`iOS Mobile Services 1.0.0`}</h3>
    <ul>
      <li parentName="ul">{`Mobile Services (mobilemarketing.adobe.com) messaging and acquisition links is now supported through the new Mobile Services extension for the Adobe Experience Platform SDK.`}</li>
    </ul>
    <h2 {...{
      "id": "april-3-2019"
    }}>{`April 3, 2019`}</h2>
    <h3 {...{
      "id": "ios-campaign-standard-101"
    }}>{`iOS Campaign Standard 1.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an issue with duplicate symbols being present in the Campaign extension library.`}</li>
    </ul>
    <h2 {...{
      "id": "march-25-2019"
    }}>{`March 25, 2019`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "ios-core-210"
    }}>{`iOS Core 2.1.0`}</h3>
    <h4 {...{
      "id": "configuration"
    }}>{`Configuration`}</h4>
    <p>{`If there is no cached configuration available, the SDK can fetch the configuration after a network restore.`}</p>
    <h4 {...{
      "id": "core"
    }}>{`Core`}</h4>
    <ul>
      <li parentName="ul">{`Added the `}<inlineCode parentName="li">{`ACPCore`}</inlineCode>{` log API, which allows third-party extensions and application developers to log messages and use the Mobile SDK `}<inlineCode parentName="li">{`LogLevel`}</inlineCode>{` to select the verbosity of the logs.`}</li>
      <li parentName="ul">{`You can also use the ACPCore `}<inlineCode parentName="li">{`getLogLevel`}</inlineCode>{` API to retrieve the current `}<inlineCode parentName="li">{`LogLevel`}</inlineCode>{` that was set in the SDK.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`trackAction`}</inlineCode>{` and `}<inlineCode parentName="li">{`trackState`}</inlineCode>{` only accept `}<inlineCode parentName="li">{`NSDictionary`}</inlineCode>{`-type context data.`}</li>
    </ul>
    <h2 {...{
      "id": "march-21-2019"
    }}>{`March 21, 2019`}</h2>
    <p>{`The `}<strong parentName="p">{`Adobe Campaign Standard`}</strong>{` extension version 1.0.0 is now available for Android!`}</p>
    <ul>
      <li parentName="ul">{`This extension allows you to deliver and track in-app messages (broadcast and personalized) and push notifications to mobile app users from Adobe Campaign Standard.`}</li>
    </ul>
    <h3 {...{
      "id": "android-core-121"
    }}>{`Android Core 1.2.1`}</h3>
    <ul>
      <li parentName="ul">{`Added protection around null results when `}<inlineCode parentName="li">{`toString`}</inlineCode>{` is called on Intent extras data.`}</li>
    </ul>
    <h2 {...{
      "id": "march-20-2019"
    }}>{`March 20, 2019`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-core-120"
    }}>{`Android Core 1.2.0`}</h3>
    <p>{`The following updates were made to the Mobile Core extension in Android version 1.2.0:`}</p>
    <h4 {...{
      "id": "configuration-1"
    }}>{`Configuration`}</h4>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`If there is no cached configuration available, you can fetch the configuration after a network restore.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Added environment-aware support, which allows you to define dev and stage environments in a property.`}</p>
        <p parentName="li"><strong parentName="p">{`Important`}</strong>{`: This overrides the config properties that were based on the default environment.`}</p>
      </li>
    </ul>
    <h4 {...{
      "id": "core-1"
    }}>{`Core`}</h4>
    <ul>
      <li parentName="ul">{`Added the `}<inlineCode parentName="li">{`MobileCore.getApplication`}</inlineCode>{` API, which allows third-party extension developers access the application context.`}</li>
      <li parentName="ul">{`Added the `}<inlineCode parentName="li">{`MobileCore.log`}</inlineCode>{` API, which allows third-party extensions and application developers to log messages and use the Mobile SDK `}<inlineCode parentName="li">{`LoggingMode`}</inlineCode>{` to select the verbosity of the logs.`}</li>
      <li parentName="ul">{`You can also use the `}<inlineCode parentName="li">{`MobileCore.getLogLevel`}</inlineCode>{` API to retrieve the current `}<inlineCode parentName="li">{`LoggingMode`}</inlineCode>{` that was set in the SDK.`}</li>
    </ul>
    <h3 {...{
      "id": "android-identity-104"
    }}>{`Android Identity 1.0.4`}</h3>
    <ul>
      <li parentName="ul">{`You can regenerate the MID when privacy settings change from opted out to opted in/opt unknown in the same session.`}</li>
    </ul>
    <h2 {...{
      "id": "march-14-2019"
    }}>{`March 14, 2019`}</h2>
    <h3 {...{
      "id": "android-core-112"
    }}>{`Android Core 1.1.2`}</h3>
    <ul>
      <li parentName="ul">{`Resolved an issue that might result in a crash when the underlying Analytics database was corrupted.`}</li>
    </ul>
    <h2 {...{
      "id": "march-7-2019"
    }}>{`March 7, 2019`}</h2>
    <h3 {...{
      "id": "android-core-111"
    }}>{`Android Core 1.1.1`}</h3>
    <ul>
      <li parentName="ul">{`Resolved an issue that could result in a crash when the underlying Analytics database was corrupted.`}</li>
    </ul>
    <h2 {...{
      "id": "march-1-2019"
    }}>{`March 1, 2019`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-core-110"
    }}>{`Android Core 1.1.0`}</h3>
    <ul>
      <li parentName="ul">{`The `}<inlineCode parentName="li">{`setSmallIcon`}</inlineCode>{` and `}<inlineCode parentName="li">{`setLargeIcon`}</inlineCode>{` APIs were added.`}</li>
    </ul>
    <h3 {...{
      "id": "android-analytics-111"
    }}>{`Android Analytics 1.1.1`}</h3>
    <ul>
      <li parentName="ul">{`Use the `}<inlineCode parentName="li">{`analytics.launchHitDelay`}</inlineCode>{` configuration setting to indicate how long to wait before Analytics launch hits are sent.`}</li>
    </ul>
    <h2 {...{
      "id": "february-28-2019"
    }}>{`February 28, 2019`}</h2>
    <p>{`The following updates were made to the `}<strong parentName="p">{`Adobe Target extension`}</strong>{`:`}</p>
    <p>{`The Target Client Code is now automatically added based on your Experience Cloud organization.`}</p>
    <ul>
      <li parentName="ul">{`If no code is found, you can type it in.`}</li>
      <li parentName="ul">{`If multiple codes are found, you can select the code from the drop-down list.`}</li>
    </ul>
    <h2 {...{
      "id": "february-20-2019"
    }}>{`February 20, 2019`}</h2>
    <p>{`The Adobe `}<strong parentName="p">{`Campaign Standard`}</strong>{` extension version 1.0.0 is now available!`}</p>
    <p>{`This extension allows you to deliver and track in-app messages (broadcast and personalized) and push notifications to mobile app users from Adobe Campaign Standard.`}</p>
    <h2 {...{
      "id": "february-19-2019"
    }}>{`February 19, 2019`}</h2>
    <h3 {...{
      "id": "ios-core-203"
    }}>{`iOS Core 2.0.3`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Bug fixes`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Added environment-aware support, which allows you to define dev and stage environments in a property.`}</p>
        <p parentName="li"><strong parentName="p">{`Important`}</strong>{`: This overrides the config properties that were based on the default environment.`}</p>
      </li>
    </ul>
    <h2 {...{
      "id": "february-7-2019"
    }}>{`February 7, 2019`}</h2>
    <h3 {...{
      "id": "ios-core-202"
    }}>{`iOS Core 2.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Resolved an issue that caused failures when retrieving a configuration on application launch.`}</li>
    </ul>
    <h2 {...{
      "id": "january-24-2019"
    }}>{`January 24, 2019`}</h2>
    <p>{`The January 24th update includes changes to the Adobe Experience Platform Mobile SDKs and solution extensions for iOS applications. We provided an explanation of this change, why the changes were made, and how to update your application to include these changes.`}</p>
    <h3 {...{
      "id": "what"
    }}>{`What`}</h3>
    <p>{`With this release, we have changed the Mobile SDK Core and all Adobe solution extensions from dynamic frameworks to static libraries.`}</p>
    <h3 {...{
      "id": "why"
    }}>{`Why`}</h3>
    <p>{`Frameworks are an excellent way to package and distribute iOS dependencies but, in some situations, using frameworks can cause issues when a dependent framework is updated. All of the Adobe Experience Platform SDK extensions have a dependency on the Core extension. This means that when a change is made to the Mobile Core framework, all dependent extensions need to be rebuilt from the source. To resolve this issue, we changed the SDK Core and all Adobe solution extensions to use static libraries.`}</p>
    <h3 {...{
      "id": "how"
    }}>{`How`}</h3>
    <p>{`There is nothing wrong or broken with the previous versions of the SDK. Apps that have already started development with the version 1.x SDK and extensions can continue in the development lifecycle with no impact. Mobile applications that have not yet started to implement the Mobile SDKs are also fine, as they will start out using the static libraries. The changes listed below are required for customers who have started implementing the Adobe Experience Platform Mobile SDK and want to update to the latest version.`}</p>
    <p>{`Please note that these changes are only for iOS.`}</p>
    <p>{`To update existing Experience Platform Mobile SDK 1.x implementations to 2.x:`}</p>
    <ol>
      <li parentName="ol">{`Use the latest installation instructions for your selected environment (development, staging, production).`}</li>
      <li parentName="ol">{`Update your Pod file with the latest changes.`}</li>
      <li parentName="ol">{`Run a 'pod update' command to pull in the latest version of the Mobile Core extension and any other solution extension updates.`}</li>
      <li parentName="ol">{`In your app code, change all of your import statements:  `}</li>
    </ol>
    <p><strong parentName="p">{`For Objective-C`}</strong></p>
    <p>{`Where you previously had imports that look like the following:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`   #import <ACPCore_iOS/ACPCore_iOS.h>
   #import <ACPIdentity_iOS/ACPIdentity_iOS.h>
   #import <ACPLifecycle_iOS/ACPLifecycle_iOS.h>
   #import <ACPSignal_iOS/ACPSignal_iOS.h>
   #import <ACPUserProfile_iOS/ACPUserProfile_iOS.h>
`}</code></pre>
    <p>{`The imports will now drop the `}<em parentName="p">{`iOS`}</em>{` suffix and can be imported directly as follows:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`   #import "ACPCore.h"
   #import "ACPIdentity.h"
   #import "ACPLifecycle.h"
   #import "ACPSignal.h"
   #import "ACPUserProfile.h"
`}</code></pre>
    <p>{`This change will hold true for any other Adobe solution extensions that you may have previously imported.`}</p>
    <p><strong parentName="p">{`For Swift`}</strong></p>
    <p>{`Where you previously had imports that looked like:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`   import ACPCore_iOS
   import ACPAnalytics_iOS
   import ACPIdentity_iOS
   import ACPLifecycle_iOS
   import ACPSignal_iOS
   import ACPUserProfile_iOS
`}</code></pre>
    <p>{`The imports will now drop the `}<em parentName="p">{`iOS`}</em>{` suffix. Additionally, the Identity, Lifecycle and Signals extensions can be added just by importing core , for example:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`    import ACPCore
    import ACPAnalytics
    import ACPUserProfile
`}</code></pre>
    <p>{`We feel that this update will serve our customers and partners better in the long run. If you have any questions or issues, go to our `}<a parentName="p" {...{
        "href": "https://experienceleaguecommunities.adobe.com/t5/adobe-experience-platform-sdks/ct-p/platform-sdk#"
      }}>{`user forum`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      